/**
 * ConstantIcon/index.js
 * desc: constant feature main navigation icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ConstantIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="constant icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.constant.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-0.00292969 6.85233L0.631888 7.06424C0.631888 7.06424 1.58388 4.31582 4.2822 4.10345C6.97868 3.89153 20.9971 3.99772 20.9971 3.99772V0.875576C20.9971 0.875576 6.33421 0.509212 3.43593 1.56326C0.525702 2.62144 -0.00292969 6.85233 -0.00292969 6.85233Z"/>
            <path d="M6.23979 3.62725C6.23979 3.62725 7.24419 12.2481 1.84893 17.6967C1.84893 17.6967 0.578377 19.9178 3.22383 21.0813C3.22383 21.0813 5.60451 21.928 6.55651 18.8063C6.55651 18.8063 7.82569 14.9988 7.93233 9.92073L8.35524 3.46729L6.23979 3.62725Z"/>
            <path d="M13.1154 3.67921L12.0586 17.0609C12.0586 17.0609 12.4806 22.8276 18.2463 20.5536C18.2463 20.5536 20.7332 19.1254 20.9433 15.1045H19.9927C19.9927 15.1045 17.9825 19.0183 16.078 17.1676C16.078 17.1676 15.0194 16.639 15.3366 11.1908L15.8666 3.62726L13.1696 3.57532"/>
        </svg>
    </IconButton>
);


export default ConstantIcon;
